<template>
    <div class="circles">
        <div class="circle c1"></div>
        <div class="circle c2"></div>
        <div class="circle c3"></div>
    </div>
</template>

<script>
    export default {
        name: 'MovingBubbles'
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .circles {
        position: fixed;
        left: 0;
        top: -8rem;
        width: 100%;
        height: 100%;
        filter: blur(8rem);
        z-index: -1;
        overflow: hidden;
    }

    .circle {
        position: absolute;
        border-radius: 100%;
        animation-iteration-count: infinite;
        animation-timing-function: cubic-bezier(.1,0,.9,1);
        opacity: 0.5;
    }

    .c1 {
        background: var(--color-blue-500);
        width: 40rem;
        height: 40rem;
        left: 50%;
        top: 50%;
        animation-duration: 16s;
        animation-name: c1;
    }

    .c2 {
        background: var(--color-violet-500);
        width: 48rem;
        height: 48rem;
        left: 60%;
        top: 40%;
        animation-duration: 16s;
        animation-name: c2;
    }

    .c3 {
        background: var(--color-primary-500);
        width: 52rem;
        height: 52rem;
        left: 45%;
        top: 60%;
        animation-duration: 16s;
        animation-name: c3;
    }

    @keyframes c1 {
        0%  { transform:translateY(-50%) translateX(-50%) rotate(-20deg) translateX(20%)}
        25% { transform:translateY(-50%) translateX(-50%) skew(-15deg,-15deg) rotate(80deg) translateX(30%)}
        50% { transform:translateY(-50%) translateX(-50%) rotate(180deg) translateX(25%)}
        75% { transform:translateY(-50%) translateX(-50%) skew(15deg,15deg) rotate(240deg) translateX(15%)}
        to  { transform:translateY(-50%) translateX(-50%) rotate(340deg) translateX(20%)}
    }

    @keyframes c2 {
        0%  { transform:translateY(-50%) translateX(-50%) rotate(40deg) translateX(-20%)}
        25% { transform:translateY(-50%) translateX(-50%) skew(15deg,15deg) rotate(110deg) translateX(-5%)}
        50% { transform:translateY(-50%) translateX(-50%) rotate(210deg) translateX(-35%)}
        75% { transform:translateY(-50%) translateX(-50%) skew(-15deg,-15deg) rotate(300deg) translateX(-10%)}
        to  { transform:translateY(-50%) translateX(-50%) rotate(400deg) translateX(-20%)}
    }

    @keyframes c3 {
        0%  { transform:translateY(-50%) translateX(-50%) translateX(-15%) translateY(10%)}
        20% { transform:translateY(-50%) translateX(-50%) translateX(20%) translateY(-30%)}
        40% { transform:translateY(-50%) translateX(-50%) translateX(-25%) translateY(-15%)}
        60% { transform:translateY(-50%) translateX(-50%) translateX(30%) translateY(20%)}
        80% { transform:translateY(-50%) translateX(-50%) translateX(5%) translateY(35%)}
        to  { transform:translateY(-50%) translateX(-50%) translateX(-15%) translateY(10%)}
    }
</style>